import type { WizardSummary } from '@hotjar/feedback/domain/common/Wizard/Wizard';
import { useTranslation } from '@hotjar/translations';
import type { WidgetPreviewProps } from '@hotjar/feedback/components/common/Wizard/WidgetPreview/WidgetPreview';
import { WidgetPreview } from '@hotjar/feedback/components/common/Wizard/WidgetPreview';
import type { SummarySectionProps } from './SummarySection';
import { SummarySection } from './SummarySection';

export const useSummarySection = (
  summaryProps: SummarySectionProps,
  previewProps: WidgetPreviewProps,
): WizardSummary => {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.summary' });
  return {
    key: 'review' as const,
    mainContent: <SummarySection {...summaryProps} />,
    sideContent: <WidgetPreview {...previewProps} />,
    title: t('title'),
    status: undefined,
    summary: '',
  };
};
